import { requestDeduplicator } from './performanceOptimizations';

const LP_TTL_MS = 15 * 60 * 1000;
const lpCache = new Map();

export async function extractMetadata(url) {
    try {
        // Sanitize incoming URL and validate
        const sanitize = (input) => {
            try {
                if (!input || typeof input !== 'string') return '';
                let s = input.trim();
                // Remove wrapping brackets/quotes commonly around pasted URLs
                s = s.replace(/^[([\\["']+/, '').replace(/[)\\]"']+$/, '');
                // Trim trailing punctuation that's not part of the URL
                s = s.replace(/[.,;:!?]+$/, '');
                // Common encoding cleanup
                s = s.replace(/\\u0026/g, '&');
                // Add scheme if missing but looks like a domain
                if (s.startsWith('www.')) {
                    s = 'https://' + s;
                }
                const u = new URL(s);
                if (!/^https?:$/.test(u.protocol)) return '';
                return u.toString();
            } catch {
                return '';
            }
        };

        const cleanUrl = sanitize(url);
        if (!cleanUrl) {
            return null;
        }

        const cached = lpCache.get(cleanUrl);
        if (cached && (Date.now() - cached.t) < LP_TTL_MS) {
            return cached.v;
        }

        const key = 'lp:' + cleanUrl;
        const result = await requestDeduplicator.request(key, async () => {
            const resp = await fetch(`https://api.microlink.io?url=${encodeURIComponent(cleanUrl)}`);
            const data = await resp.json();

            if (!resp.ok || data.status !== 'success' || !data.data) {
                try {
                    if (typeof window !== 'undefined' && window.__WHT_LP_DEBUG) {
                        console.warn('[LinkPreview] Microlink request failed', {
                            url: cleanUrl,
                            httpStatus: resp.status,
                            payload: data
                        });
                    }
                } catch { }
                return null;
            }

            return {
                url: cleanUrl,
                title: data.data.title || '',
                description: data.data.description || '',
                image: data.data.image?.url || '',
                domain: new URL(cleanUrl).hostname.replace('www.', '')
            };
        });

        if (result) {
            lpCache.set(cleanUrl, { v: result, t: Date.now() });
        }

        return result;
    } catch (error) {
        try {
            if (typeof window !== 'undefined' && window.__WHT_LP_DEBUG) {
                console.warn('[LinkPreview] extractMetadata error', error);
            }
        } catch { }
        return null;
    }
}